import React, {useEffect, useMemo, useRef} from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Progress from "../../../../../../ui/Progress";
import NoData from "./NoData";
import AddButton from "../../../../../../ui/AddButton";
import ExpandPanelBlock from "./ExpandPanelBlock";
import AddBlockDialog from "./AddBlockDialog";
import AddModuleDialog from "./AddModuleDialog";
import {getProgramBlocks, getAllProgramModules} from "../../../../store/actions";
import {createProgramBlock, updateProgramBlock,
  includeProgramModule} from "../../../../store/send";
import {deleteProgramBlock, excludeProgramModule} from "../../../../store/delete";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  container: {
    width: "100%",
    marginTop: "16px"
  },
  heading: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px"
  },
  title: {
    fontSize: 14,
    lineHeight: "18px",
    color: "#000000",
    marginRight: "8px",
  },
  mainGrid:{
    marginTop: 8
  },
});

const ProgramModulesEdit = ({classes, programId, disabled,
                              getProgramBlocks,
                              allProgramBlock,
                              createProgramBlock,
                              updateProgramBlock,
                              createdProgramBlock,
                              fetchingAddProgramBlock,
                              updatedProgramBlock,
                              fetchingUpdateProgramBlock,
                              deleteProgramBlock,
                              getAllProgramModules,
                              allProgramModule,
                              includeProgramModule,
                              excludeProgramModule
}) => {
  const [addBlockModal, setAddBlockModal] = React.useState(false);
  const [addModuleModal, setAddModuleModal] = React.useState(false);
  const [updateBlockOpen, setUpdateBlockOpen] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openDeleteModuleModal, setOpenDeleteModuleModal] = React.useState(false);
  const [expandedBlock, setExpandedBlock] = React.useState();
  const [selectedBlock, setSelectedBlock] = React.useState(null);
  const [selectedModule, setSelectedModule] = React.useState(null);

const createBlock = (main) => {
  createProgramBlock(programId, main)
}

const updateBlock = (main) => {
  //updateProgramBlock(programId, selectedBlock,main );
}

const addModuleToBlock = (main) => {
  const data = {
    blockId: selectedBlock,
    main: main
  }

  includeProgramModule(programId, data)
}

  const handleChangeBlockPanel = panel => (event, newExpandedVolume) => {
    setExpandedBlock(newExpandedVolume ? panel : false);
  };

  useEffect(() => {
    if (programId && programId > 0) {
      getProgramBlocks(programId);
      getAllProgramModules(programId);
    }
  }, [programId]);

  return (
    <div className={classes.root}>
      <AddBlockDialog open={addBlockModal}
                      handleClose={() => setAddBlockModal(false)}
                      type="add"
                      programId={programId}
                      addBlock={createBlock}
                      updateBlock={updateBlock}/>
      <AddModuleDialog open={addModuleModal}
                      handleClose={() => setAddModuleModal(false)}
                      handleConfirm={addModuleToBlock}/>
      <DeleteConfirmationModal
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        modalText="Удалить блок?"
        onConfirm={() => deleteProgramBlock(programId, selectedBlock)}
      />
      <DeleteConfirmationModal
        open={openDeleteModuleModal}
        handleClose={() => setOpenDeleteModuleModal(false)}
        modalText="Исключить модуль из состава учебной программы?"
        onConfirm={() => excludeProgramModule(programId, selectedModule)}
      />
      <div className={classes.heading}>
        <Typography className={classes.title}>
          Блоки модулей
        </Typography>
        <AddButton
          onClick={() => {
            setSelectedBlock(null);
            setAddBlockModal(true);
          }}
        />
      </div>
      {allProgramBlock && allProgramBlock.length > 0 ? (
        <div>
          {allProgramBlock.map(block => (
            <ExpandPanelBlock block={block}
                              modules={allProgramModule && allProgramModule.filter(module => module.blockId === block.id)}
                              openModulesDialog={() => setAddModuleModal(true)}
                              expandedBlock={expandedBlock}
                              handleChangeBlockPanel={handleChangeBlockPanel}
                              setSelectedBlock={setSelectedBlock}
                              setSelectedModule={setSelectedModule}
                              setUpdateBlockOpen={setUpdateBlockOpen}
                              setOpenDeleteModal={() => setOpenDeleteModal(true)}
                              setOpenDeleteModuleModal={() => setOpenDeleteModuleModal(true)}/>
          ))}
        </div>
      ) : (
        <NoData title="Ни одного блока программы еще не добавлено" desc="Добавьте блоки" />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  allProgramBlock: state.programConstruct.allProgramBlock,
  allProgramModule: state.programConstruct.allProgramModule,
  createdProgramBlock: state.programConstruct.createdProgramBlock,
  fetchingAddProgramBlock: state.programConstruct.fetchingAddProgramBlock,
  updatedProgramBlock: state.programConstruct.updatedProgramBlock,
  fetchingUpdateProgramBlock: state.programConstruct.fetchingUpdateProgramBlock
});

const mapDispatchToProps = dispatch => ({
  getProgramBlocks: (id) => dispatch(getProgramBlocks(id)),
  getAllProgramModules: (id) => dispatch(getAllProgramModules(id)),
  createProgramBlock: (id, data) => dispatch(createProgramBlock(id, data)),
  updateProgramBlock: (id, blockId, data) => dispatch(updateProgramBlock(id, blockId, data)),
  deleteProgramBlock: (id, blockId) => dispatch(deleteProgramBlock(id, blockId)),
  includeProgramModule: (id, data) => dispatch(includeProgramModule(id, data)),
  excludeProgramModule: (id, moduleId) => dispatch(excludeProgramModule(id, moduleId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProgramModulesEdit));
